import parse, { HTMLReactParserOptions } from "html-react-parser";

import { Text } from "@krea/customer-features/shared-components/text";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";

interface IFreeTextParserProps {
  text: string;
}

const FreeTextParser = ({ text }: IFreeTextParserProps) => {
  const htmlParserOptions: HTMLReactParserOptions = {
    trim: true,
    replace: (domNode) => {
      if (domNode.type === ("text" as typeof domNode.type)) {
        return (
          <Text
            className={twMerge({
              "tw-mb-2 tw-font-bold": domNode.next,
              "tw-mt-2": !domNode.prev && domNode.next,
              "tw-mb-0": !domNode.next,
            })}
          >
            {"data" in domNode ? domNode.data : ""}
          </Text>
        );
      }

      if ("name" in domNode && domNode.name === "br") {
        return <></>;
      }
    },
  };

  return parse(text.replace(/(\r\n|\n|\r)/gm, "<br />"), htmlParserOptions);
};

export default FreeTextParser;
